// import { useState, useEffect } from 'react';

// // Custom hook to monitor ongoing uploads/downloads
// const useTaskWatcher = () => {
//   const [hasOngoingTask, setHasOngoingTask] = useState(false);

//   const checkProgress = () => {
//     const keys = Object.keys(localStorage);
//     const ongoing = keys.some((key) => {
//       if (key.includes('progress')) {
//         const progress = parseFloat(localStorage.getItem(key));
//         return progress > 0 && progress < 100;
//       }
//       return false;
//     });
//     setHasOngoingTask(ongoing);
//   };

//   useEffect(() => {
//     // Check storage at regular intervals (for same-tab updates)
//     const intervalId = setInterval(checkProgress, 1000);

//     // Cross-tab changes
//     const handleStorageChange = () => checkProgress();
//     window.addEventListener('storage', handleStorageChange);

//     return () => {
//       clearInterval(intervalId);
//       window.removeEventListener('storage', handleStorageChange);
//     };
//   }, []);

//   useEffect(() => {
//     const preventUnload = (event) => {
//       event.preventDefault();
//       event.returnValue = 'There are ongoing tasks. Do you want to leave?';
//     };

//     if (hasOngoingTask) {
//       window.addEventListener('beforeunload', preventUnload);
//     } else {
//       window.removeEventListener('beforeunload', preventUnload);
//     }

//     return () => window.removeEventListener('beforeunload', preventUnload);
//   }, [hasOngoingTask]);

//   return hasOngoingTask;
// };

// export default useTaskWatcher;

import { useState, useEffect } from 'react';

// Custom hook to monitor ongoing uploads/downloads
const useTaskWatcher = () => {
  const [hasOngoingTask, setHasOngoingTask] = useState(false);

  const clearStaleProgress = () => {
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      if (key.includes('progress')) {
        localStorage.removeItem(key);
      }
    });
  };

  const checkProgress = () => {
    const keys = Object.keys(localStorage);
    const ongoing = keys.some((key) => {
      if (key.includes('progress')) {
        const progress = parseFloat(localStorage.getItem(key));
        return progress > 0 && progress < 100;
      }
      return false;
    });
    setHasOngoingTask(ongoing);
  };

  useEffect(() => {
    // Clear stale progress when the component mounts
    clearStaleProgress();

    // Check storage at regular intervals (for same-tab updates)
    const intervalId = setInterval(checkProgress, 1000);

    // Cross-tab changes
    const handleStorageChange = () => checkProgress();
    window.addEventListener('storage', handleStorageChange);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const preventUnload = (event) => {
      event.preventDefault();
      event.returnValue = 'There are ongoing tasks. Do you want to leave?';
    };

    if (hasOngoingTask) {
      window.addEventListener('beforeunload', preventUnload);
    } else {
      window.removeEventListener('beforeunload', preventUnload);
    }

    return () => window.removeEventListener('beforeunload', preventUnload);
  }, [hasOngoingTask]);

  return hasOngoingTask;
};

export default useTaskWatcher;
